import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  headerContainer: {
    position: "relative",
    background: "#17A5B1",
    height: "140px",
    opacity: 0.88,
    width: "100%",
  },
  backgroundImage: {
    height: "140px",
  },

  title: {
    color: "white",
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.4rem",
    },
  },
  copyButton: {
    color: "white",
    borderColor: "white",
    width: 42,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      width: "15%",
      marginLeft: 0,
    },
  },
  version: {
    color: "white",
    textDecoration: "underline",
    marginLeft: theme.spacing(1),
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(2),
    },
  },
  lastUpdated: {
    marginLeft: theme.spacing(1),
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "row",
    },
  },
  updated: {
    color: "white",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  creator: {
    color: "white",
    marginLeft: theme.spacing(0.5),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  createBtn: {
    color: "white",
    borderColor: "white",
    marginRight: theme.spacing(1),
    width: 171,
    fontSize: 12,
    [theme.breakpoints.down("sm")]: {
      width: "45%",
    },
  },
  menu: {
    color: "white",
    width: 180,
    backgroundColor: theme.palette.primary.main,
    marginTop: "34px",
  },
  snackBar: {
    zIndex: 2000,
    backgroundColor: "#fff",
  },
  star: {
    color: "#fff",
    fontSize: "12px",
    marginLeft: theme.spacing(0.25),
    marginRight: theme.spacing(1),
  },
}))

export default styles
